import axios from 'axios';
import type { SelectEntity } from '@getaccept/lib-shared/src/select-entity/types/select-entity';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';
import { GraphQLFetchPolicy } from '@getaccept/lib-shared/src/graphql/graphql-fetch-policy';
import { samlUrl as samlUrlQuery } from './graphql/select-entity.queries';

export class SelectEntityService {
  static async entities(): Promise<SelectEntity[]> {
    const { data } = await axios.get('/get/login/entities');
    if (!data.entities) {
      throw new Error(data);
    }
    return data.entities.map(entity => ({
      auth: entity.auth,
      id: entity.id,
      name: entity.name,
      plan: entity.plan,
      planTitle: entity.plan_title,
      role: entity.role,
    }));
  }

  static async selectEntity(entityId: string): Promise<boolean> {
    const cachebuster: number = Math.round(new Date().getTime() / 1000);
    const body = new FormData();
    body.append('entity-id', entityId);
    const { data } = await axios.post(`/get/login/entity?${cachebuster}`, body);
    if (data.status !== 1) {
      throw new Error(data);
    }
    return true;
  }

  static async getSamlUrl(entityId: string): Promise<string> {
    const {
      data: { samlUrl },
    } = await apolloClientInternal.query({
      query: samlUrlQuery,
      variables: { entityId },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return samlUrl;
  }
}
